import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudTypographyModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { TabComponent } from './tab.component';

@NgModule({
	declarations: [TabComponent],
	imports: [CommonModule, TranslateModule.forChild(), FreudTypographyModule],
	exports: [TabComponent],
})
export class TabModule {}
